import { render, staticRenderFns } from "./SectionInstructors.vue?vue&type=template&id=02dd44c5&scoped=true"
import script from "./SectionInstructors.vue?vue&type=script&lang=js"
export * from "./SectionInstructors.vue?vue&type=script&lang=js"
import style0 from "./SectionInstructors.vue?vue&type=style&index=0&id=02dd44c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd44c5",
  null
  
)

export default component.exports